import React, { useMemo } from "react";
import { Checkbox } from "../";
import IconButton from "../icon-button";
import "./TransactionDetails.css";
import { HiClipboardCopy } from "react-icons/hi";

export default function TransactionDetails({
  fileTypeId,
  fileTypes,
  transaction,
  childDetails,
  includeParticulars,
  setIncludeParticulars,
  includeCode,
  setIncludeCode,
  includeReference,
  setIncludeReference,
  includeDoUpsertMatch,
  setIncludeDoUpsertMatch,
  onCopy,
}) {
  if (!transaction) return null;

  function handleCopyToClipboard(text) {
    if (onCopy) {
      onCopy(text);
    }
  }

  const fileType = useMemo(() => {
    if (!Array.isArray(fileTypes) || fileTypes.length === 0) return "N/A";
    // Prefer the transaction's exportTypeId (updated optimistically) and fallback to the bank record's fileTypeId
    const id = (transaction?.exportTypeId ?? fileTypeId) ?? null;
    if (id == null) return "N/A";
    return fileTypes.find((ft) => ft.fileTypeId === id)?.typeName ?? "N/A";
  }, [transaction?.exportTypeId, fileTypeId, fileTypes]);


  return (
    <div className="transaction-details-section">
      <div className="transaction-details-grid">
        <div className="transaction-info">
          <div className="transaction-field">
            <span className="field-label">Amount:</span>
            <span className="field-value">${transaction.amount?.toFixed(2) || "0.00"}</span>
          </div>
          <div className="transaction-field">
            <span className="field-label">Date:</span>
            <span className="field-value">
              {transaction.date
                ? new Date(transaction.date).toLocaleDateString("en-NZ", { day: "2-digit", month: "2-digit", year: "numeric" })
                : "N/A"}
            </span>
          </div>
          <div className="transaction-field">
            <span className="field-label">Type:</span>
            <span className="field-value">{transaction.type || "N/A"}</span>
          </div>
          <div className="transaction-field">
            <span className="field-label">File Type:</span>
            <span className="field-value">{fileType || "N/A"}</span>
          </div>
          <div className="transaction-field">
            <span className="field-label">Other Party:</span>
            <span className="field-value">{transaction.otherParty || "N/A"}</span>
          </div>
          <div className="transaction-field">
            <span className="field-label">Account:</span>
            <span className="field-value">{transaction.otherPartyAccount || "N/A"}</span>
          </div>
        </div>
        {childDetails && childDetails?.childId > 0 && (
          <div className="child-details-info">
            <div className="transaction-field">
              <span className="field-label">Child ID:</span>
              <span className="field-value">{childDetails.childId || "N/A"}</span>
            </div>
            <div className="transaction-field">
              <span className="field-label">First Name:</span>
              <span className="field-value">{childDetails.firstName || "N/A"}</span>
            </div>
            <div className="transaction-field">
              <span className="field-label">Surname:</span>
              <span className="field-value">{childDetails.surname || "N/A"}</span>
            </div>
            <div className="transaction-field">
              <span className="field-label">Family Name:</span>
              <span className="field-value">{childDetails.familyName || "N/A"}</span>
            </div>
            <div className="transaction-field">
              <span className="field-label">Centre:</span>
              <span className="field-value">{childDetails.centreName ? childDetails.centreName : "N/A"}</span>
            </div>
          </div>
        )}
        <div className="transaction-checkboxes">
          <div className="checkbox-group">
            <Checkbox
              className="transaction-checkbox"
              checked={includeDoUpsertMatch || false}
              onChange={(e) => {
                const val = e && e.target !== undefined ? e.target.checked : e;
                setIncludeDoUpsertMatch(val);
              }}
            />
            <div className="transaction-field">
              <span className="field-label">Create Match:</span>
            </div>
          </div>
          <div className="checkbox-group">
            <Checkbox
              className="transaction-checkbox"
              checked={includeParticulars || false}
              onChange={(e) => {
                // support both event and boolean signatures
                const val = e && e.target !== undefined ? e.target.checked : e;
                setIncludeParticulars(val);
              }}
              disabled={includeDoUpsertMatch === false}
            />
            <div className="transaction-field">
              <span className="field-label">Particulars:</span>
              <span className="field-value">{transaction.particulars || "N/A"}</span>
              
            </div>
            <IconButton
                className="copy-details-button"
                icon={<HiClipboardCopy />}
                width={40}
                height={40}
                data-testid="child-search-btn"
                onClick={() => handleCopyToClipboard(transaction.particulars)}
              />
          </div>
          <div className="checkbox-group">
            <Checkbox
              className="transaction-checkbox"
              checked={includeCode || false}
              onChange={(e) => {
                const val = e && e.target !== undefined ? e.target.checked : e;
                setIncludeCode(val);
              }}
              disabled={includeDoUpsertMatch === false}
            />
            <div className="transaction-field">
              <span className="field-label">Code:</span>
              <span className="field-value">{transaction.code || "N/A"}</span>
            </div>
             <IconButton
                className="copy-details-button"
                icon={<HiClipboardCopy />}
                width={40}
                height={40}
                data-testid="child-search-btn"
                onClick={() => handleCopyToClipboard(transaction.code)}
              />
          </div>
          <div className="checkbox-group">
            <Checkbox
              className="transaction-checkbox"
              checked={includeReference || false}
              onChange={(e) => {
                const val = e && e.target !== undefined ? e.target.checked : e;
                setIncludeReference(val);
              }}
              disabled={includeDoUpsertMatch === false}
            />
            <div className="transaction-field">
              <span className="field-label">Reference:</span>
              <span className="field-value">{transaction.reference || "N/A"}</span>
              
            </div>
            <IconButton
                className="copy-details-button"
                icon={<HiClipboardCopy />}
                width={40}
                height={40}
                data-testid="child-search-btn"
                onClick={() => handleCopyToClipboard(transaction.reference)}
              />
          </div>
        </div>
      </div>
    </div>
  );
}
